import React, { useEffect, useState } from 'react';
// import Card from "../../components/elements/Card";
import AdminLayout from '../../components/layout/admin';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import { useMutation, useQuery } from '@tanstack/react-query';
import { showNotification } from '../../utilities/mantineNotification';
import {
  Avatar,
  Flex,
  Image,
  Indicator,
  Popover,
  Tabs,
  Text,
  ThemeIcon,
  Title,
  Card,
  Badge,
  Button,
  Group,
  Grid,
  Container,
  Center,
  TextInput,
  Autocomplete,
  SegmentedControl,
  Stack
} from '@mantine/core';
import * as Unicons from '@iconscout/react-unicons';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';
import LabelDate from '../../components/fragments/LabelDate';
import DataTables from '../../components/elements/DataTables';
import LoadingIllustration from '../../components/fragments/IllustrationState/LoadingIllustration';
import ModalWrapper from '../../components/elements/ModalWrapper';
import {
  injectPoint,
  listRiwayat,
  listUser,
  searchUser
} from '../../services/injectPoint';

function useDebounce(callback, delay) {
  const [timer, setTimer] = useState(null);

  const debouncedCallback = (...args) => {
    if (timer) {
      clearTimeout(timer);
    }
    const newTimer = setTimeout(() => {
      callback(...args);
    }, delay);
    setTimer(newTimer);
  };

  useEffect(() => {
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [timer]);

  return debouncedCallback;
}

const InjectPoint = (props) => {
  const [oldEmail, setOldEmail] = useState('');
  const [listUserSearch, setListUserSearch] = useState([]);
  const [point, setPoint] = useState(0);
  const [modalAdd, setModalAdd] = useState(false);

  const [prosesSearchOldEmail, setProsesSearchOldEmail] = useState(false);

  const [listOldEmail, setListOldEmail] = useState([]);

  const [modalDialog, setModalDialog] = useState({
    show: false,
    data: null
  });

  const _handleInjectUser = (e: any) => {
    e.preventDefault();

    setModalDialog({
      show: true,
      data: null
    });
  };

  const handleSearchUser = () => {
    const payload = {
      keyword: oldEmail,
      page: 1,
      take: 20
    };
    _searchUser.mutate(payload);
  };

  const _searchUser = useMutation({
    mutationFn: searchUser,
    onSuccess: (data) => {
      setListUserSearch(data?.data?.data || []);
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const handleMutate = () => {
    const parts = oldEmail.split(' - ');
    const binusianID = parts[0];

    const payload = {
      binusianID: binusianID,
      point: point
    };
    handleInjectPoint.mutate(payload);
  };

  const handleInjectPoint = useMutation({
    mutationFn: injectPoint,
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Success Inject Point User'
      });
      setModalDialog({
        show: false,
        data: null
      });
      setModalAdd(false);
      fetchedDataRiwayat.refetch();
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const columns = [
    {
      heading: 'Binusian Name',
      props: 'namaBinusian',
      id: 'namaBinusian',
      sortable: true
    },
    {
      heading: 'Injected Point',
      props: 'point',
      id: 'point',
      sortable: true
    },
    {
      heading: 'Injected By',
      props: 'userIn',
      id: 'userIn',
      sortable: true
    },
    {
      heading: 'Injected At',
      props: (item) => renderDate(item, 'dateIn'),
      id: 'dateIn',
      sortable: true
    }

    // {
    //   heading: 'Action',
    //   props: 'action',
    //   sortable: false
    // }
  ];

  const renderDate = (item, key) => <LabelDate date={item[key]} />;

  const [modalConfig, setModalConfig] = useState({
    show: false,
    data: null,
    type: ''
  });

  const fetchedDataRiwayat = useQuery({
    queryKey: [`riwayat`, props.auth?.email],
    queryFn: () => listRiwayat(),
    enabled: true
  });

  const debouncedRefetch = useDebounce(() => {
    handleSearchUser();
  }, 1000);

  useEffect(() => {
    if (oldEmail !== '') {
      debouncedRefetch();
    }
  }, [oldEmail]);

  const fetchedDataUser = useQuery({
    queryKey: [`listUser`, props.auth?.email],
    queryFn: () => listUser(oldEmail),
    enabled: true
  });

  const dataUser = listUserSearch.map(
    (item) => `${item.binusianId} - ${item.fullName} (${item.email})`
  );

  const loadingState =
    fetchedDataRiwayat.isLoading || fetchedDataRiwayat.isLoading;

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle="Inject Point"
        itemList={[
          {
            title: 'BCL&D Back Office',
            href: '#',
            icon: <Unicons.UilFileCopyAlt />
          },
          {
            title: 'Inject Point',
            href: 'management/inject-point'
          }
        ]}
      />
      {loadingState && (
        <LoadingIllustration
          description="Please wait... Currently collecting data..."
          title="Preparing Data"
        />
      )}
      {!loadingState && (
        <>
          <Card>
            <Flex
              style={{
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Stack mb={10} gap={'xs'}>
                <Title order={4}>History Inject Point</Title>
                <Text size="sm">
                  Below is the list of history inject point.
                </Text>
              </Stack>
              <>
                <Button
                  color="#7B2183"
                  radius="md"
                  onClick={() => {
                    setModalAdd(true);
                  }}
                >
                  Inject Point
                </Button>
              </>
            </Flex>
            <DataTables
              columns={columns}
              loading={false}
              data={fetchedDataRiwayat.data?.data?.data || []}
            />
          </Card>
        </>
      )}
      <ModalWrapper
        title="Injecting Point"
        isVisible={modalAdd}
        onClose={() => {
          setModalAdd(false);
        }}
        size={'xl'}
      >
        <Group justify="space-between" mt="md" mb="xs">
          <Text fw={500}>
            If you want to inject point to the user then you can use this form,
            you also need to declare the binusian email and the point
          </Text>
        </Group>
        <form onSubmit={_handleInjectUser}>
          <Autocomplete
            label="Email"
            placeholder="johndoe@provider.com"
            radius={'md'}
            required
            onChange={(value) => setOldEmail(value)}
            value={oldEmail}
            data={dataUser || []}
          />
          <TextInput
            label="Point"
            placeholder="100"
            radius={'md'}
            type="number"
            required
            onChange={(event) => setPoint(Number(event.target.value))}
            value={point}
          />
          <Button color="#7B2183" fullWidth mt="md" radius="md" type="submit">
            {fetchedDataUser.isLoading ? 'Loading...' : 'Inject Point'}
          </Button>
        </form>
        <ModalConfirmation
          isVisible={modalDialog.show}
          type="Submit Data"
          loading={handleInjectPoint.isLoading}
          onCancel={() => {
            setModalDialog({
              show: false,
              data: null
            });
          }}
          onConfirm={() => {
            handleMutate();
          }}
        />
      </ModalWrapper>
    </AdminLayout>
  );
};

function checkIsEmailValid(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export default InjectPoint;
